<div class="thread-detail">
  <div class="container detail-container">
    <!-- Thread Information -->
    <div class="section" *ngIf="threadData?.thread">
      <h3>Thread Information</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Created:</label>
          <span>{{ formatDate(threadData.thread.created_at) }}</span>
        </div>
        <div class="info-item">
          <label>Updated:</label>
          <span>{{ formatDate(threadData.thread.updated_at) || 'N/A' }}</span>
        </div>
      </div>
    </div>

    <!-- User Information -->
    <div class="section" *ngIf="threadData?.account_app_user">
      <h3>User Information</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Name:</label>
          <span>{{ formatUserName(threadData.account_app_user) }}</span>
        </div>
        <div class="info-item">
          <label>Email:</label>
          <span>{{ threadData.account_app_user.email || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <label>Location:</label>
          <span>{{ threadData.account_app_user.profile?.location || 'N/A' }}</span>
        </div>
        <div class="info-item">
          <label>Created:</label>
          <span>{{ formatDate(threadData.account_app_user.created_at) }}</span>
        </div>
      </div>
    </div>

    <!-- Device Information -->
    <div class="section" *ngIf="threadData?.device">
      <h3>Device Information</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Device:</label>
          <span>{{ formatDeviceInfo(threadData.device) }}</span>
        </div>
        <div class="info-item">
          <label>Created:</label>
          <span>{{ formatDate(threadData.device.created_at) }}</span>
        </div>
      </div>
    </div>

    <!-- Extracted Data Section -->
    <div class="section" *ngIf="categoriesFromExtractedData.length > 0">
      <h3>{{ getSectionTitle() }}</h3>
      <div class="results-content">
        <div class="categories-container">
          <div class="category" *ngFor="let category of categoriesFromExtractedData">
            <h5 class="category-name">{{ category.name }}</h5>
            <div class="category-info">
              <span class="total-documents">Available {{ documentLabelPlural }}: {{ category.totalDocuments }}</span>
            </div>
            <div class="tag-groups">
              <div class="tag-group" *ngFor="let tagGroup of category.tag_groups">
                <div class="tag-group-header">
                  <span class="group-name">{{ tagGroup.group_name }}</span>
                </div>
                <div class="chips-container">
                  <mat-chip-list>
                    <mat-chip *ngFor="let tag of tagGroup.tags" color="primary" selected>
                      {{ tag }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Thread Messages -->
    <div class="section" *ngIf="threadData?.openai_history?.length">
      <h3>Thread Messages</h3>
      <div class="messages-container">
        <div class="message" *ngFor="let message of reversedMessages; let i = index" [class.tripist-message]="i === 0">
          <div class="message-header">
            <span class="message-role">{{ getMessageRole(message, i) }}</span>
            <span class="message-time" *ngIf="message?.created_at">{{ formatMessageTime(message.created_at) }}</span>
          </div>
          <div class="message-content">
            <pre *ngIf="getDisplayMessageContent(message)">{{ getDisplayMessageContent(message) }}</pre>
            <div *ngIf="getPresentChoiceToolCalls(message).length > 0" class="tool-call-data">
              <ul class="choice-tool-calls-list">
                <li class="choice-tool-call-item" *ngFor="let choiceCall of getPresentChoiceToolCalls(message)">
                  <ul class="choice-options-list" *ngIf="choiceCall.options.length > 0">
                    <li *ngFor="let option of choiceCall.options">
                      <span class="choice-option-pill" [class.choice-option-escape]="option.style === 'escape'">
                        {{ option.label }}
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Assistant Results Query -->
    <div class="section" *ngIf="categoriesFromThreadResults.length > 0">
      <h3>Assistant Results Query</h3>
      <div class="tool-call-data">
        <div class="categories-container">
          <div class="category" *ngFor="let category of categoriesFromThreadResults">
            <h4 class="category-name">{{ category.name }}</h4>
            <div class="tag-groups">
              <div class="tag-group" *ngFor="let tagGroup of category.tag_groups">
                <div class="tag-group-header">{{ tagGroup.group_name }}</div>
                <div class="chips-container">
                  <mat-chip *ngFor="let tag of tagGroup.tags" class="mat-chip">
                    {{ tag }}
                  </mat-chip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Query Results -->
    <div class="section" *ngIf="queryResults.length > 0">
      <h3>Query Results</h3>
      <div class="query-results">
        <div class="result-item" *ngFor="let result of queryResults">
          <div class="result-header">
            <h4 class="result-name">{{ result.name }}</h4>
            <span class="result-subtitle" *ngIf="result.subtitle">{{ result.subtitle }}</span>
          </div>
          <div class="result-content">
            <div class="result-image" *ngIf="result.image">
              <img [src]="result.image" [alt]="result.name" />
            </div>
            <div class="result-details">
              <p class="result-description" *ngIf="result.description">{{ result.description }}</p>
              <div class="result-url" *ngIf="result.url">
                <a [href]="result.url" target="_blank" rel="noopener noreferrer">View {{ documentLabelSingular }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Aura Booking Events -->
    <div class="section" *ngIf="auraBookingEvents.length > 0">
      <h3>Aura Booking Events</h3>
      <div class="query-results">
        <div class="result-item" *ngFor="let event of auraBookingEvents">
          <div class="result-header">
            <h4 class="result-name">{{ formatBookingEventLabel(event) }}</h4>
            <span class="result-subtitle">{{ formatDate(event.event_at || event.persisted_at) }}</span>
          </div>
          <div class="result-content">
            <div class="result-details">
              <p><strong>Status:</strong> {{ event.status || 'N/A' }}</p>
              <p><strong>Booking Ref:</strong> {{ event.booking_reference || 'N/A' }}</p>
              <p><strong>Provider Booking ID:</strong> {{ event.provider_booking_id || 'N/A' }}</p>
              <p><strong>{{ documentLabelSingular }} ID:</strong> {{ event.document_id || 'N/A' }}</p>
              <p><strong>Start:</strong> {{ event.schedule?.start_at ? formatDate(event.schedule.start_at) : 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rating & Feedback -->
    <div class="section" *ngIf="threadData?.thread">
      <h3>Rating & Feedback</h3>
      <div class="info-grid">
        <div class="info-item">
          <label>Rating:</label>
          <span>{{ formatRating(threadData.thread.rating) }}</span>
        </div>
        <div class="info-item">
          <label>Shares:</label>
          <span>{{ threadData.thread.shares || 0 }}</span>
        </div>
      </div>
      <div class="info-grid" *ngIf="threadData.thread.feedback">
        <div class="info-item">
          <label>Feedback:</label>
          <span>{{ threadData.thread.feedback }}</span>
        </div>
      </div>
    </div>

    <!-- No Data Message -->
    <div class="no-data" *ngIf="!threadData">
      <p>No thread data found.</p>
    </div>
  </div>
</div>

<!-- Loading State -->
<div class="loading-container" *ngIf="loading">
  <div class="loading-spinner">
    <p>Loading thread details...</p>
  </div>
</div>
